/**
 * @flow
 */
import React from 'react'
import {Button, CircularProgress, withStyles} from '@material-ui/core'

export interface PrimaryButtonProps {
  label: string;
  onClick?: () => void;
  submit?: boolean;
  loading?: boolean;
  icon?: React$Node;
  fullWidth?: boolean;
  outlined?: boolean;
  size?: any;
  disabled?: boolean;
}

const PrimaryButton = (props: PrimaryButtonProps) => {
  const {classes} = props;
  if(props.loading) {
    return (
      <div className={classes.wrapper}>
        <Button
          disabled={props.loading ?? props.disabled ?? false}
          type={props.submit ? 'submit' : undefined}
          className={'capitalize'}
          variant={props.outlined === true ? 'outlined' : 'contained'}
          color={'primary'}
          onClick={props.onClick}
          startIcon={props.icon}
          children={props.label}
          fullWidth={props.fullWidth ?? false}
          size={props.size}
        />
        {props.loading && (
          <CircularProgress
            size={24}
            className={classes.buttonProgress}
          />
        )}
      </div>
    );
  } else {
    return (
      <Button
        type={props.submit ? 'submit' : undefined}
        className={'capitalize'}
        variant={props.outlined === true ? 'outlined' : 'contained'}
        color={'primary'}
        startIcon={props.icon}
        onClick={props.onClick}
        children={props.label}
        fullWidth={props.fullWidth ?? false}
        size={props.size}
        disabled={props.disabled ?? false}
      />
    );
  }
};

const styles = theme => ({
  wrapper: {
    position: "relative"
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
});

export default withStyles(styles, {withTheme: true})(PrimaryButton);
